import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';
import type { ReduxError } from '@universal/errors';
import { messagesResponse } from '../../../../types/messageType';

// Actions
export enum Actions {
  GET_MESSAGES = 'naf/GET_MESSAGES',
  GET_MESSAGES_SUCCESS = 'naf/GET_MESSAGES_SUCCESS',
  GET_MESSAGES_FAIL = 'naf/GET_MESSAGES_FAIL',
  GET_MESSAGES_CANCEL = 'naf/GET_MESSAGES_CANCEL',
}

export interface State {
  messageList: messagesResponse;
  isUpdating: boolean;
  errorState?: any;
}

export const initialState: State = {
  messageList: {
    messages: [],
  },
  isUpdating: false,
};

export const actions = {
  getMyMessages: createAsyncAction(
    Actions.GET_MESSAGES, // request payload creator
    Actions.GET_MESSAGES_SUCCESS, // success payload creator
    Actions.GET_MESSAGES_FAIL, // failure payload creator
    Actions.GET_MESSAGES_CANCEL, // optional cancel payload creator
  )<undefined, messagesResponse, ReduxError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getMyMessages.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = true;
    }),
  )
  .handleAction(actions.getMyMessages.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.errorState = false;
      draftState.messageList = {
        ...action.payload,
        messages: action.payload.messages.map((msg) => ({ ...msg, id: msg.id ?? crypto.randomUUID() })),
      };
    }),
  )
  .handleAction(actions.getMyMessages.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.errorState = action.payload;
    }),
  )
  .handleAction(actions.getMyMessages.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
    }),
  );
